var _defs, _path, _polygon, _circle, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew202({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.14,5.81V1.33h.63L14.2,3.59A11.64,11.64,0,0,1,15,5.05h0C15,4.44,15,3.9,15,3.2V1.33h.54V5.81h-.58L13.49,3.53A13.15,13.15,0,0,1,12.66,2h0c0,.56,0,1.1,0,1.84V5.81Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.05 12.98 11.31 5.6 2.79 5.6 7.05 12.98"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.05,
    cy: 8.12,
    r: 4.86
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 7.05,
    y1: 3.11,
    x2: 7.05,
    y2: 1.56
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 7.05,
    y1: 14.67,
    x2: 7.05,
    y2: 13.13
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.06,
    y1: 8.12,
    x2: 13.61,
    y2: 8.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.5,
    y1: 8.12,
    x2: 2.05,
    y2: 8.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew202);
export default __webpack_public_path__ + "static/media/Symbolpack_New_202.a9ca7a47a031128496f9934ba8a0a1be.svg";
export { ForwardRef as ReactComponent };